//配置全局访问接口地址
let commonUrl = "alloyok8@gmail.com";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl